import { assign } from 'xstate';

import config from 'config';
import assertEventType from 'common/bento/lib/assertEventType';
import { MachineActions } from 'common/bento/types/MachineConfig';

import { Model } from './model';

const CREATE_COMPANY_LINK = `${config.publicWebsiteUrl}/creation-entreprise/`;

export enum Action {
  AssignCompanyLegalForm = 'assignCompanyLegalForm',
  ClearApplicationType = 'clearApplicationType',
  ClearCompanyContext = 'clearCompanyContext',
  GoToCreateCompany = 'goToCreateCompany',
}

const actions: MachineActions<Model, Action> = {
  assignCompanyLegalForm: assign({
    companyLegalForm: (context, event) => {
      assertEventType(event, 'SUBMIT_COMPANY_CREATION_LEGAL_FORM');

      return event.data;
    },
  }),

  clearApplicationType: ({ getModuleData }) => {
    getModuleData().applicationTypeContext.dispatch(null);
  },

  clearCompanyContext: ({ getModuleData }) => {
    getModuleData().companyContext.setCompanyContext({
      companyProfileId: undefined,
      companyUserId: undefined,
    });
  },

  goToCreateCompany: () => {
    window.location.href = CREATE_COMPANY_LINK;
  },
};

export default actions;
